import Container from '@mui/system/Container';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { HEADER_HEIGHT } from '../../data/constants';
import { TopContainer } from '../common';
import Breadcrumbs, { BREADCRUMBS_HEIGHT } from '../policyholder/Breadcrumbs';
import PolicyholderActions from '../policyholder/PolicyholderActions';
import PolicyholderSidebar from '../policyholder/Sidebar/PolicyholderSidebar';
import LeftSidebarLayout from './LeftSidebarLayout';

const PolicyholderLayout = () => {
	const renderActions = () => {
		return <PolicyholderActions />;
	};

	return (
		<LeftSidebarLayout
			leftSidebarContent={<PolicyholderSidebar />}
			mainContent={
				<>
					<TopContainer>
						<Breadcrumbs />
						{renderActions()}
					</TopContainer>
					<Container
						maxWidth='lg'
						sx={{
							height: `calc(100vh - ${HEADER_HEIGHT}px - ${BREADCRUMBS_HEIGHT}px)`,
							pt: 4,
							pb: 4,
						}}
					>
						<Outlet />
					</Container>
				</>
			}
		/>
	);
};

export default PolicyholderLayout;
